import APP from 'src/main.js'
import AppRecord from './AppRecord.js'

class EntityAllocation extends AppRecord {
  get allocation_limits(){
    const assetClassMapping = this.constructor.employeeStore.assetClasses.reduce((map, assetClass) => {
      map[assetClass.name] = assetClass.id;
      return map;
    }, {});

    const assetClassGroupMapping = this.constructor.employeeStore.asset_class_groups.reduce((map, group) => {
      map[group.id] = group.sort_order;
      return map;
    }, {});

    return this.constructor.employeeStore.allocation_limits.filter(alloc => alloc.entity_allocation_id === this.id).sort((a, b) => {
      const assetClassIdA = assetClassMapping[a.asset_class];
      const assetClassIdB = assetClassMapping[b.asset_class];

      if (assetClassIdA !== assetClassIdB) {
        return assetClassIdA - assetClassIdB;
      }
    
      // Check if asset_class_group_id is missing in either object
      if (a.asset_class_group_id == null && b.asset_class_group_id != null) {
        return -1; // Place 'a' before 'b'
      } else if (b.asset_class_group_id == null && a.asset_class_group_id != null) {
        return 1; // Place 'b' before 'a'
      }

      const sortOrderA = assetClassGroupMapping[a.asset_class_group_id];
      const sortOrderB = assetClassGroupMapping[b.asset_class_group_id];
    
      return sortOrderA - sortOrderB;
    })
  }

  get isStrategy(){
    if (this.allocation_type == 'strategy') {
      return true
    }

    return false
  }

  get strategyReportingPercentage(){
    return this.allocation_limits.reduce((sum, item) => {
      if (item.asset_class_group_id === null) {
        // return sum + Math.round(item.reporting_pct, 2);
        return sum + item.reporting_pct;
      }
      return sum;
    }, 0)
  }

  get validateErrors(){
    if (!this.isStrategy || (this.allocation_limits || {}).length === 0) { return null }
    
    // For an allocation to be valid, all allocation_limits without asset_class_groups must count up to 100%
    let errors = this.isAssetClassGroupsValid

    if (parseFloat(this.strategyReportingPercentage.toFixed(2)) != 1){
      if (! errors){
        errors = []
        errors.push("Den totale sum af base-aktivklasser (dvs. poster uden underaktivklasser) giver ikke 100% men " + ((this.strategyReportingPercentage || 0) * 100).round(2) + '%')
        errors.push('')
      }

    }

    return errors
  }

  get isAssetClassGroupsValid(){
    if (!this.isStrategy || (this.allocation_limits || {}).length === 0){
      return null
    }

    let errors = null;
    const assetClasses = this.allocation_limits.filter(x => x.isPrimary && x.secondaryAllocationLimits.length > 0)

    assetClasses.forEach(ac => {
      const acgs = this.allocation_limits.filter(x => x.asset_class == ac.asset_class && x.asset_class_group_id != null)

      const totalSum = acgs.reduce((sum, item) => {
        return sum + item.formatted_reporting_pct;
      }, 0)
  
      if (totalSum.round(4) != ac.formatted_reporting_pct.round(4)){
        const err = 'På aktivklasse ' + ac.asset_class + ' er angivet en strategisk vægt på ' + ac.formatted_reporting_pct + ' og den totale sum af de underliggende underaktivklasser er ' + totalSum.round(4)
        if (!errors){
          errors = []
        }
        errors.push(err)

        if ((errors || {}).length > 0){
          errors.push('')
          errors.push("Det er et krav at summen af alle poster MED en underaktivklasse skal summe op til totalen på den post der ikke har en underaktivklasse. Dvs. at der skal være en post med KUN eks. Aktier og så skal alle underliggende poster med Aktier OG en underaktivklasse, stemme overens.")
          errors.push('')
        }
      }
    });
    
    return errors
  }

  get allocationStatusDescription(){
    let message = ''
    if (this.allocation_status === 'template'){
      message = " (Kladde)"
    } else if (this.allocation_status === 'closed'){
      message = " (Lukket)"
    } else if (this.entity_benchmark){
      message = " (Automatisk)"
    }

    if ((this.validateErrors || {}).length > 0){
      message += " (Ikke gyldig)"
    }

    return message
  }

  get errorText(){
    let error_message = ''
    this.validateErrors.forEach((x) => {
      error_message += x + '\n'
    })

    return error_message
  }

  get canEdit(){
    if (this.entity_benchmark){
      return false
    }
    if (this.allocation_status && this.allocation_status === 'template'){
      return true
    }

    return false
  }

  get hoverText(){
    let text = ''
    if (this.isStrategy){
      this.allocation_limits.forEach((alloc) => {
        if (alloc.isPrimary){
          text += (alloc.assetClassDescription + ': ' + alloc.formatted_reporting_pct + '%\n')
        }
      })
    } else {
      this.allocation_limits.forEach((alloc) => {
        text += alloc.assetClassDescription + ': ' + alloc.formatted_min_pct + '% - ' + alloc.formatted_max_pct + "%\n"
      })
    }
    return text
  }
}

export default EntityAllocation
